module.exports = __webpack_public_path__ + "media/images/illust/illust-longlife-f4a58e708481d018c691b7aa4fe2b2f9.svg";